import React, { Suspense, useRef, useState, useEffect } from 'react';
import { Canvas, useThree } from 'react-three-fiber';
import { Sky, Box, PositionalAudio, Sphere, Stars } from 'drei';
import { Physics } from 'use-cannon';
import * as THREE from "three"

import { Ground } from './components/Ground';
import { Player } from './components/Player';
import { Hud } from './components/Hud';

import skeleton_obj from "/Users/egrigokhan/Downloads/minecraft-react-master/src/Horse.glb";
import skeleton_dae from "/Users/egrigokhan/Downloads/minecraft-react-master/src/skeleton.dae";

import { faCopy, faPlus, faTrash, faRocket, faLaptop } from '@fortawesome/free-solid-svg-icons';
import { faGithub, faTwitter, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// WebRTC
import io from "socket.io-client";
import Peer from "simple-peer";
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { ColladaLoader } from 'three/examples/jsm/loaders/ColladaLoader';

import { CSS3DRenderer, CSS3DObject } from 'three/examples/jsm/renderers/CSS3DRenderer.js';

import './App.css'

// Bootstrap
import { Navbar, Nav, NavDropdown, Form, FormControl, Button, Row, Col, Container, Card, Badge, ListGroup } from 'react-bootstrap';

function Room_App(props) {

    const peerObjectsDict = {};

    const [stream, setStream] = useState(null)
    const [listenerForPA, setListenerForPA] = useState();

    const [sendStarted, setSendStarted] = useState(false);

    const audioSource = useRef();

    const playerRef = useRef();

    const container_ref = useRef();
    const scene_ref = useRef();

    // const peerPositionalAudioRef = useRef();
    const physicsRef = useRef();

    const [peers, setPeers] = useState([]);
    const socketRef = useRef();
    const userAudio = useRef();
    const peersRef = useRef([]);
    const roomID = props.match.params.roomID;

    useEffect(() => {
        socketRef.current = io.connect("https://haunter-server.herokuapp.com/");
        console.log(socketRef.current)
        navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
            // userAudio.current.srcObject = stream;
            socketRef.current.emit("join room", roomID);
            socketRef.current.on("all users", users => {
                const peers = [];
                users.forEach(userID => {
                    const peer = createPeer(userID, socketRef.current.id, stream);
                    peersRef.current.push({
                        peerID: userID,
                        peer,
                    })
                    peers.push(peer);
                })
                setPeers(peers);
            })

            socketRef.current.on("user joined", payload => {
                const peer = addPeer(payload.signal, payload.callerID, stream);
                console.log("peer joined")
                console.log(peer)

                peersRef.current.push({
                    peerID: payload.callerID,
                    peer,
                })

                setPeers(users => [...users, peer]);
            });

            socketRef.current.on("receiving returned signal", payload => {
                const item = peersRef.current.find(p => p.peerID === payload.id);
                item.peer.signal(payload.signal);
            });

            socketRef.current.on("move", playerMotion => {
                // console.info(playerMotion);
                // console.info(peerObjectsDict)

                if(peerObjectsDict[playerMotion.peerID]) {
                    console.info("found")
                    peerObjectsDict[playerMotion.peerID].position.set(playerMotion.position)
                    peerObjectsDict[playerMotion.peerID].rotation.set(playerMotion.rotation)
                }
            });
        })
    }, []);

    function createPeer(userToSignal, callerID, stream) {
        const peer = new Peer({
            initiator: true,
            trickle: false,
            stream,
        });

        peer.on("signal", signal => {
            socketRef.current.emit("sending signal", { userToSignal, callerID, signal })
        })

        peer.on("stream", stream => {

            if(peerObjectsDict[userToSignal] === null | peerObjectsDict[userToSignal] === undefined) {
                const listener = new THREE.AudioListener();

                setListenerForPA(listener)

                const peerPositionalAudioRef = new THREE.PositionalAudio( listener );

                peerPositionalAudioRef.setMediaStreamSource(stream);

                peerPositionalAudioRef.setRefDistance(5);
                peerPositionalAudioRef.setMaxDistance(20);
                peerPositionalAudioRef.setRolloffFactor(5);
                peerPositionalAudioRef.setVolume(1);

                const geometry = new THREE.CylinderGeometry(0.2, 0.2, 1);
                const material = new THREE.MeshBasicMaterial( {color: 0x00ff00} );
                const peerBoxRef = new THREE.Mesh( geometry, material );
                peerBoxRef.position.set(-10 + Math.random() * (20), 0, -10 + Math.random() * (20));

                peerPositionalAudioRef.context.resume()

                peerPositionalAudioRef.play();

                peerPositionalAudioRef.autoplay = true;

                peerBoxRef.add(peerPositionalAudioRef);
                physicsRef.current.add(peerBoxRef)

                console.log(peer)
                peerObjectsDict[userToSignal] = peerBoxRef;

                console.info(peerObjectsDict);
            }
            
            /**
            if(peerObjectsDict[userToSignal] === null | peerObjectsDict[userToSignal] === undefined) {
                const listener = new THREE.AudioListener();

                setListenerForPA(listener)
    
                const peerPositionalAudioRef = new THREE.PositionalAudio( listener );
    
                peerPositionalAudioRef.setMediaStreamSource(stream);
    
                peerPositionalAudioRef.setRefDistance(5);
                peerPositionalAudioRef.setMaxDistance(20);
                peerPositionalAudioRef.setRolloffFactor(5);
                peerPositionalAudioRef.setVolume(1);
    
                // const geometry = new THREE.BoxGeometry( 1, 1, 1 );
                // const material = new THREE.MeshBasicMaterial( {color: 0x00ff00} );

                const objLoader = new ColladaLoader();
                objLoader.load(skeleton_dae, (root) => {
                console.log("skeleton root", root)
                root.scene.position.set(0, 0, 0)
                root.scene.scale.set(0.01, 0.01, 0.01)
                root.scene.children[4].scale.set(0.5, 0.5, 0.5)
                const peerBoxRef = (root.scene.children[4])

                peerBoxRef.position.set(0, 1.5, -10 + Math.random() * (20));
  
                peerBoxRef.add(peerPositionalAudioRef);
                physicsRef.current.add(peerBoxRef)
    
                peerPositionalAudioRef.context.resume()
    
                peerPositionalAudioRef.autoplay = true;
    
                console.log(peer)
                peerObjectsDict[userToSignal] = peerBoxRef;
    
                console.info(peerObjectsDict);
                });
            }
            */
        })

        peer.on("data", (e) => {

            const playerMotion = JSON.parse(e);
            console.info(playerMotion);

            /**
            for (var key in peerObjectsDict) {
                console.log("set")
                peerObjectsDict[key].position.set(playerMotion.position.x,playerMotion.position.y, playerMotion.position.z)
                peerObjectsDict[key].rotation.set(playerMotion.rotation._x,playerMotion.rotation._y, playerMotion.rotation._z)
                // peerObjectsDict[key].rotation.set(playerMotion.rotation)
            }
            */
           console.info(peerObjectsDict)

            if(peerObjectsDict[userToSignal]) {
                console.log("set")
                peerObjectsDict[userToSignal].position.set(playerMotion.position.x,playerMotion.position.y, playerMotion.position.z)
                peerObjectsDict[userToSignal].rotation.set(playerMotion.rotation._x,playerMotion.rotation._y,playerMotion.rotation._z)
            }

            /**
            const playerMotion = JSON.parse(e);
            if(peerObjectsDict[peer._id]) {
                console.info("found")
                peerObjectsDict[peer._id].position.set(playerMotion.position)
                peerObjectsDict[peer._id].rotation.set(playerMotion.rotation)
            }
            */
        });

        return peer;
    }

    function addPeer(incomingSignal, callerID, stream) {
        const peer = new Peer({
            initiator: false,
            trickle: false,
            stream,
        })

        peer.on("signal", signal => {
            socketRef.current.emit("returning signal", { signal, callerID })
        })

        peer.on("stream", stream => {

            if(peerObjectsDict[callerID] === null | peerObjectsDict[callerID] === undefined) {
                const listener = new THREE.AudioListener();

                setListenerForPA(listener)

                const peerPositionalAudioRef = new THREE.PositionalAudio( listener );

                peerPositionalAudioRef.setMediaStreamSource(stream);

                peerPositionalAudioRef.setRefDistance(5);
                peerPositionalAudioRef.setMaxDistance(20);
                peerPositionalAudioRef.setRolloffFactor(5);
                peerPositionalAudioRef.setVolume(10);

                const geometry = new THREE.CylinderGeometry(0.2, 0.2, 1);
                const material = new THREE.MeshBasicMaterial( {color: 0x00FF00} );
                const peerBoxRef = new THREE.Mesh( geometry, material );
                peerBoxRef.position.set(-10 + Math.random() * (20), 0, -10 + Math.random() * (20));

                peerPositionalAudioRef.context.resume()

                peerPositionalAudioRef.play();

                peerPositionalAudioRef.autoplay = true;

                peerBoxRef.add(peerPositionalAudioRef);
                physicsRef.current.add(peerBoxRef)

                console.log(peer)
                peerObjectsDict[callerID] = peerBoxRef;

                console.info(peerObjectsDict);
            }
        })

        peer.on("data", (e) => {
            const playerMotion = JSON.parse(e);
            console.info(playerMotion);

            /**
            for (var key in peerObjectsDict) {
                console.log("set")
                peerObjectsDict[key].position.set(playerMotion.position.x,playerMotion.position.y, playerMotion.position.z)
                peerObjectsDict[key].rotation.set(playerMotion.rotation._x,playerMotion.rotation._y, playerMotion.rotation._z)
                //peerObjectsDict[key].rotation.set(playerMotion.rotation)
            }
            */
           console.info(peerObjectsDict)

            if(peerObjectsDict[callerID]) {
                console.log("set")
                peerObjectsDict[callerID].position.set(playerMotion.position.x,playerMotion.position.y, playerMotion.position.z)
                peerObjectsDict[callerID].rotation.set(playerMotion.rotation._x,playerMotion.rotation._y,playerMotion.rotation._z)
            }
        });

        peer.signal(incomingSignal);

        return peer;
    }

    const disconnectFromRoom = (e) => {

    }

    /**
    // YOUTUBE
    var camera = useThree();
    var scene, renderer;

    var Element = function ( id, x, y, z, ry ) {

        console.info("element");

        var div = document.createElement( 'div' );
        div.style.width = '480px';
        div.style.height = '360px';
        div.style.backgroundColor = '#000';

        var iframe = document.createElement( 'iframe' );
        iframe.style.width = '480px';
        iframe.style.height = '360px';
        iframe.style.border = '0px';
        iframe.src = [ 'https://www.youtube.com/embed/', id, '?rel=0' ].join( '' );
        div.appendChild( iframe );

        var object = new CSS3DObject( div );
        object.position.set( x, y, z );
        object.rotation.y = ry;

        console.info(object)

        return object;

    };

    init();
    // animate();

    function init() {


    }

    function animate(group) {

        renderer.render( group, camera );

    }

    useEffect(() => {
        if(scene_ref.current) {

            var container = document.getElementById( 'container' );
        
            renderer = new CSS3DRenderer();
            renderer.setSize( window.innerWidth, window.innerHeight );
            renderer.domElement.style.position = 'absolute';
            renderer.domElement.style.top = 0;
            document.body.appendChild( renderer.domElement );
    
            // window.addEventListener( 'resize', onWindowResize, false );

            console.info("adding youtube")
            var group = scene_ref.current;
            group.add( new Element( 'Gu2gLd8Nyzs', 0, 0, 0, 0 ) );
            group.add( new Element( 'pJn6eVNeLmM', 0, 0, 0, Math.PI / 2 ) );
            group.add( new Element( 'WM8bTdBs-cw', 0, 0, - 0, Math.PI ) );
            group.add( new Element( 'o1tj2zJ2Wvg', - 0, 0, 0, - Math.PI / 2 ) );

            animate(group);
        }
    }, [scene_ref.current]);


    */
  return (
      <>
     <Navbar style={{marginLeft: '8px', marginRight: '8px'}} sticky="top" expand="md">
                <Navbar.Brand style={{color: 'inherit', marginRight: '8px'}}>👻 <b>haunter</b></Navbar.Brand>
                <Nav style={{background: 'none !important'}} className="ml-auto">
                    <Nav.Item style={{color: 'inherit'}}>{roomID ? <Navbar.Text style={{color: 'inherit'}} className="small">{roomID} [<a onClick={(e) => {disconnectFromRoom(e)}} style={{color: 'red', cursor: 'pointer'}}>disconnect</a>]</Navbar.Text> : <Navbar.Text style={{color: 'inherit'}} className="small">Not connected</Navbar.Text>}</Nav.Item>
                </Nav>
            </Navbar>

    <Canvas shadowMap colorManagement onClick={(e) => {setSendStarted(true)}} style={{height: '100vh', position: 'absolute', top: '0px', bottom: '0px'}}>
      {true && <Stars
        color="black"
        radius={100} // Radius of the inner sphere (default=100)
        depth={50} // Depth of area where stars should fit (default=50)
        count={5000} // Amount of stars (default=5000)
        factor={4} // Size factor (default=4)
        saturation={0} // Saturation 0-1 (default=0)
        fade // Faded dots (default=false)
        />}
      {false && <Sky/>}
      <ambientLight intensity={0.25} />
      <pointLight castShadow intensity={0.7} position={[100, 100, 100]} />
      <group ref={scene_ref}></group>
      <Physics gravity={[0, 0, 0]}>
        <Ground position={[0, 0, 0]} />
        <Player sendStarted={true} peersRef={peersRef} socketRef={socketRef} listenerForPA={listenerForPA} position={[0, 3, 10]} />
        <group ref={physicsRef}></group>
      </Physics>
    </Canvas>

    <Navbar style={{height: '60px', width: 'calc(100% - 16px)', position: 'absolute', top: 'calc(100vh - 60px)', marginLeft: '8px', marginRight: '8px'}} sticky="bottom" className="footer" expand="sm">
                <Navbar.Text className="small" style={{color: 'inherit'}}>© Gokhan Egri 2021</Navbar.Text>
                <Nav className="ml-auto">
                    <Row>
                        <Col style={{padding: '0px', color: 'inherit'}}><Nav.Link style={{display: 'inline-block', color: 'inherit'}} href="https://egrigokhan.github.io"><FontAwesomeIcon icon={faLaptop} size="sm"/></Nav.Link></Col>
                        <Col style={{padding: '0px', color: 'inherit'}}><Nav.Link style={{display: 'inline-block', color: 'inherit'}} href="https://github.com/egrigokhan"><FontAwesomeIcon icon={faGithub} size="sm"/></Nav.Link></Col>
                        <Col style={{padding: '0px', color: 'inherit'}}><Nav.Link style={{display: 'inline-block', color: 'inherit'}} href="https://twitter.com/gokhan_egri"><FontAwesomeIcon icon={faTwitter} size="sm"/></Nav.Link></Col>
                        <Col style={{padding: '0px', color: 'inherit'}}><Nav.Link style={{display: 'inline-block', color: 'inherit'}} href="https://www.linkedin.com/in/gokhan-egri"><FontAwesomeIcon icon={faLinkedin} size="sm"/></Nav.Link></Col>
                    </Row>
                </Nav>
            </Navbar>
    </>
  );
}

export default Room_App;
